import type { FieldValues, Resolver } from 'react-hook-form';
import type { ObjectSchema } from 'yup';

import { yupResolver } from '@hookform/resolvers/yup';

/**
 * Typed bridge over the yup 0.29 / @hookform/resolvers v5 version skew.
 *
 * The resolver package is typed against yup v1 (4-generic `ObjectSchema`,
 * v1 `InferType`), so with `@types/yup@0.29` its output generic collapses to
 * an unusable shape and every `useForm({ resolver })` call errors. The cast
 * is contained here — call sites stay cast-free:
 *
 *   resolver: formResolver<FormValues>(schema)
 *
 * Remove this helper when yup is upgraded to v1.
 */
export const formResolver = <TFieldValues extends FieldValues>(
  schema: ObjectSchema<object | null | undefined>,
): Resolver<TFieldValues> => yupResolver(schema as never) as unknown as Resolver<TFieldValues>;
